import React, { FC, memo, useCallback, useEffect, useState } from 'react'
import classes from './SingleInputHeader.module.scss'
import { useGetWorkerInfo } from '../../../hooks/api/workers/useGetWorkerInfo'
import { Switch, TextField, useTheme } from '@mui/material'
import SingleDatePicker from '../../uikit/atoms/datepickers/SingleDatePicker'
//キャンセル
import CancelIcon from '@mui/icons-material/Cancel'
import {
  compareTimeTable,
  getTimesDownTo,
  getTimesUpTo,
  timeList,
} from '../../../utils/variables/timeList'
import SelectBoxForString from '../../uikit/atoms/selectboxes/SelectBoxForString'
import {
  calcTotalTimeByDiary,
  calcTotalTimeByFromAndTo,
} from '../../../utils/functions/calcTotalTime'
import { useRecoilState } from 'recoil'
import { userState } from '../../../states/userState'
import { User, Worker } from '../../../types'
import { workerInfoType } from '../SingleInputMain'
import { Dirary } from '../../../types/dirary'
import { setUserToLocalStorage } from '../../../utils/functions/localStorageManager'
import { formatDate } from '../../../utils/functions/formatting'
import { useGetDiaryList } from '../../../hooks/api/posts/useGetDiraryList'
import { Buttons } from '../../uikit/atoms/buttons/Buttons'
import { createTimeFixedArray } from '../../../utils/functions/updateDiaryTime'
import PersonSearchIcon from '@mui/icons-material/PersonSearch'
import WorkerSearchDialog from '../../modal/workerSearch/WorkerSearchDialog'
import { formatWorkerId } from '../../../utils/variables/workerId'
import NightShiftToggle from '../../uikit/molecules/NightShiftToggle'
import DarkModeIcon from '@mui/icons-material/DarkMode'
import { isRadioExerciseDiary } from '../../../utils/functions/createDefaultDiary'
import {
  NIGHT_SHIFT_DEFAULT_START,
  NIGHT_SHIFT_THRESHOLD_MIN,
  SHIFT_TYPE_NIGHT,
  SHIFT_TYPE_NORMAL,
} from '../../../utils/variables/shift'

const padTwo = (n: number) => String(n).padStart(2, '0')
const timeToMin = (t: string) => {
  const [h, m] = t.split(':').map(Number)
  return h * 60 + m
}
//夜勤2直対応: 終了時刻ラベル(§4.2)。24h超え(endMin>1440)のときのみ「（翌 H:mm）」併記。
//endMin<=1440 は現行同様(=1440 は「24時00分」)。
const formatEndTimeLabel = (endMin: number): string => {
  const base = `${padTwo(Math.floor(endMin / 60))}時${padTwo(endMin % 60)}分`
  if (endMin > 1440) {
    return `${base}（翌 ${Math.floor((endMin % 1440) / 60)}:${padTwo(
      endMin % 60
    )}）`
  }
  return base
}
type Props = {
  setTotalTime: React.Dispatch<
    React.SetStateAction<{ hour: number; min: number; text: string }>
  >
  totalTime: { hour: number; min: number; text: string }
  workerInfo: {
    workerId: string
    workerName: string
    departmentId: null | number
    departmentName: null | string
    place: null | string
  }
  setWorkerInfo: React.Dispatch<React.SetStateAction<workerInfoType>>
  workingDate: {
    obj: Date
    text: string
  }
  setWorkingDate: React.Dispatch<
    React.SetStateAction<{
      obj: Date
      text: string
    }>
  >

  // setHasBreak: React.Dispatch<React.SetStateAction<boolean>>;
  fromTime: string
  toTime: string
  setFromTime: React.Dispatch<React.SetStateAction<string>>
  setToTime: React.Dispatch<React.SetStateAction<string>>
  setFetchDiaryList: React.Dispatch<React.SetStateAction<Dirary[]>>
  diaryList: Dirary[]
  setDiaryList: React.Dispatch<React.SetStateAction<Dirary[]>>
  setIsShow?: React.Dispatch<React.SetStateAction<boolean>>
  fromOtherPage?: boolean
  shiftType: number //夜勤2直対応
  setShiftType: React.Dispatch<React.SetStateAction<number>>
  hasExistingReports: boolean //夜勤2直対応(brush-up): 既存日報の有無(トグルdisabled/15:00ジャンプ判定)
  endMin: number //当日終了の通算分(終了時刻表示の翌時刻併記に使用)
}

const SingleInputHeader: FC<Props> = memo((props) => {
  const {
    totalTime,
    setTotalTime,
    workerInfo,
    setWorkerInfo,
    workingDate,
    setWorkingDate,
    fromTime,
    setFromTime,
    setToTime,
    setFetchDiaryList,
    diaryList,
    setDiaryList,
    setIsShow = undefined,
    fromOtherPage = false,
    shiftType,
    setShiftType,
    hasExistingReports,
    endMin,
  } = props
  const [user, setUser] = useRecoilState<User>(userState)
  const theme = useTheme()
  const getWorkerInfo = useGetWorkerInfo()
  const { getDiaryListByWokerAndDay } = useGetDiaryList()
  const [isWorkerSearchOpen, setIsWorkerSearchOpen] = useState(false)
  //社員マスタ情報-4
  // const [workerInfo, setWorkerInfo] = useState({
  //   workerId: "",
  //   workerName: "",
  //   departmentId: null,
  //   departmentName: null,
  //   place: null,
  // });

  //エラーメッセージ-2
  const [errorWorkerName, setErrorWorkerName] = useState({
    isShow: true,
    text: '',
  })

  const [fromTimeList, setFromTimeList] =
    useState<{ id: string; name: string }[]>(timeList)
  const [toTimeList, setToTimeList] =
    useState<{ id: string; name: string }[]>(timeList)

  // const [toTimeList, setToTimeList] = useState<{ id: string; name: string }[]>(
  //   getTimesDownTo(timeList, fromTime)
  // );

  //社員番号入力
  const handleChangeWorkerId = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.value.length <= 5) {
      setWorkerInfo((prevState) => ({
        ...prevState,
        workerId: e.target.value,
      }))
      if (e.target.value.length == 0) {
        setErrorWorkerName({ isShow: true, text: '' })
      } else {
        setErrorWorkerName({ isShow: false, text: '' })
      }
      // setErrorWorkerName({ isShow: true, text: "未設定" });
    }
  }
  //フォーカスが当たったとき
  const handleFocusWorkerId = () => {
    //フェッチ用のリストを初期化
    setFetchDiaryList([])
    setWorkerInfo((prevState) => ({
      ...prevState,
      workerId: '',
      workerName: '',
      departmentId: null,
      departmentName: null,
      place: null,
      jobId: null,
    }))
    setErrorWorkerName({ isShow: true, text: '' })
    //リコイルを更新
    setUser((prevUser: User) => {
      const newUser: User = {
        ...prevUser,
        initialParameters: {
          ...prevUser.initialParameters,
          workerSingleForInput: null,
        },
      }
      setUserToLocalStorage(newUser)
      return newUser
    })
  }
  //フォーカスが外れたとき
  const handleBlurWorkderId = async () => {
    try {
      if (workerInfo.workerId.length > 0) {
        const res = await getWorkerInfo(workerInfo.workerId)
        if (res) {
          const lworkerId = res[5]

          setWorkerInfo((prevState) => ({
            ...prevState,
            workerId: formatWorkerId(res[5]),
            workerName: res[0],
            departmentId: res[1],
            departmentName: res[6],
            place: res[3],
            jobId: res[2],
          }))
          setErrorWorkerName({
            isShow: false,
            //text: `${res[6]}`,
            text: '',
          })
          //リコイルを更新
          setUser((prevUser: User) => {
            const newWorker: Worker = {
              workerId: formatWorkerId(res[5]),
              workerName: res[0],
            }
            const newUser: User = {
              ...prevUser,
              initialParameters: {
                ...prevUser.initialParameters,
                workerSingleForInput: newWorker,
              },
            }
            setUserToLocalStorage(newUser)
            return newUser
          })
          const response = await getDiaryListByWokerAndDay(
            lworkerId,
            workingDate.text
          )

          // setDiaryList(response);
          setFetchDiaryList(response)
        } else {
          setFetchDiaryList([])
          setWorkerInfo((prevState) => ({
            ...prevState,
            workerName: '',
            departmentId: null,
            departmentName: null,
            place: null,
            jobId: null,
          }))
          setErrorWorkerName({ isShow: true, text: '' })
          //リコイルを更新
          setUser((prevUser: User) => {
            const newUser: User = {
              ...prevUser,
              initialParameters: {
                ...prevUser.initialParameters,
                workerSingleForInput: null,
              },
            }
            setUserToLocalStorage(newUser)
            return newUser
          })
        }
      }
    } catch (e: unknown) {
      if (e instanceof Error) {
        window.alert('日報の取得に失敗しました: ' + e.message)
      } else {
        window.alert('予期せぬエラーが発生しました。')
      }

      if (setIsShow) setIsShow(false)
    }
  }
  //作業開始日が変更されたとき
  const handleWorkingDateChange = (newDate: any) => {
    setWorkingDate({ obj: newDate, text: formatDate(newDate) })
  }
  //brush-up 2026-06-17改訂: ラジオ体操の自動削除条件。
  //「真の初回(保存済0件) かつ フォームがラジオ体操唯一の1件」のときだけ削除する。
  //複数明細があるとき(初回でも)は消さない。トグルON・開始時刻↑跨ぎの両経路で共用。
  const isPristineRadioOnly = () =>
    !hasExistingReports &&
    diaryList.length === 1 &&
    isRadioExerciseDiary(diaryList[0])
  //開始時刻が変更されたとき
  const handleFromTimeChange = (e: string) => {
    //夜勤2直対応: ユーザ操作時のみ閾値跨ぎで自動判定(§4.3)。
    //プログラム的 setFromTime(読込復元等)はこの関数を通らないため発火しない。
    const oldMin = timeToMin(fromTime)
    const newMin = timeToMin(e)
    if (newMin < NIGHT_SHIFT_THRESHOLD_MIN) {
      setShiftType(SHIFT_TYPE_NORMAL) //12:00未満 → 自動OFF(+ トグルはdisabled)
    } else if (oldMin < NIGHT_SHIFT_THRESHOLD_MIN) {
      //12:00未満→以上に跨いだ → 自動ON(brush-up: 夜勤化時はラジオ体操を除去)
      setShiftType(SHIFT_TYPE_NIGHT)
      //ラジオ削除は「真の初回 かつ ラジオ唯一」のときだけ。開始時刻はユーザの選択値を尊重(15:00にはしない)。
      if (isPristineRadioOnly()) {
        setDiaryList((prev) => prev.filter((d) => !isRadioExerciseDiary(d)))
      }
    }
    //12:00以上同士の変更(13:00→13:30等)は手動OFFを尊重し維持(何もしない)
    setFromTime(e)
  }
  //夜勤2直対応(brush-up 2026-06-17改訂): 夜勤トグル操作。
  //・ラジオ削除: 「真の初回 かつ ラジオ唯一」(isPristineRadioOnly)のときだけ。
  //・15:00自動セット: ラジオ削除後にフォームが空(=空 or ラジオ唯一) かつ 開始<12:00 のときだけ。
  //  既存編集や実明細ありのトグルでは時刻据置・ラジオ据置(shiftType変更＋再計算のみ)。OFFは時刻不変。
  const handleShiftToggle = (next: number) => {
    if (next === SHIFT_TYPE_NIGHT) {
      const pristine = isPristineRadioOnly()
      if (pristine) {
        setDiaryList((prev) => prev.filter((d) => !isRadioExerciseDiary(d)))
      }
      const willBeEmpty = pristine || diaryList.length === 0
      if (willBeEmpty && timeToMin(fromTime) < NIGHT_SHIFT_THRESHOLD_MIN) {
        setFromTime(NIGHT_SHIFT_DEFAULT_START)
      }
    }
    setShiftType(next)
  }
  useEffect(() => {
    //終了時刻強制セット
    // if (compareTimeTable(fromTime, toTime)) setToTime(toTimeList[0].id);
  }, [toTimeList])
  //時刻計算
  // useEffect(() => {
  //   // const { hour, min, text } = calcTotalTimeByFromAndTo(
  //   //   fromTime,
  //   //   toTime,
  //   //   hasBreak
  //   // );
  //   const { hour, min, text, endTime } = calcTotalTimeByDiary(
  //     fromTime,
  //     diaryList
  //     // hasBreak
  //   );
  //   setTotalTime({ hour, min, text });
  //   setToTime(endTime);
  //   setDiaryList((prevList) => {
  //     const timeFixedList = createTimeFixedArray(fromTime, prevList);
  //     return timeFixedList.map((diary: Dirary) => {
  //       // if (diary.workingDate === workingDate.text) {
  //       return {
  //         ...diary,
  //         // startTime: fromTime,
  //         // endTime: endTime,
  //         // isBreak: hasBreak,
  //         totalWorkingTimeByHour: hour,
  //         totalWorkingTimeByMinute: min,
  //       };
  //       // } else {
  //       //   return diary;
  //       // }
  //     });
  //   });
  //   // }, [fromTime, toTime, hasBreak]);
  // }, [fromTime, toTime]);
  //親要素の時刻更新
  // useEffect(() => {
  //   // setTotalTime(totalTime);
  //   setDiaryList((prev) => {
  // }, [totalTime]);
  //読み込み時の社員情報フェッチ
  useEffect(() => {
    handleBlurWorkderId()
  }, [workingDate.text, workerInfo.workerName])
  const checkFromTimeDisabled = useCallback(() => {
    if (diaryList.length > 0 && diaryList[0].isDisabled) {
      return true
    } else {
      return false
    }
  }, [diaryList])

  return (
    <div className={classes.rootContainer}>
      <div className={classes.workerArea}>
        <div className={classes.kanaButton}>
          <p style={{ fontSize: '12px' }}>カナ検索</p>
          <Buttons
            disabled={false}
            onClick={() => setIsWorkerSearchOpen(true)}
            caption={'カナ'}
            icon={<PersonSearchIcon />}
            width={26}
            height={26}
            fontSize={24}
          />
        </div>
        <div className={`${classes.date}`}>
          <SingleDatePicker
            disabled={false}
            currentDate={workingDate.obj}
            label={'作業日'}
            onChange={handleWorkingDateChange}
          />
        </div>
        <div className={classes.input}>
          <TextField
            helperText={errorWorkerName.text}
            error={errorWorkerName.isShow}
            label="社員番号"
            variant="standard"
            type="number"
            multiline={false}
            value={workerInfo.workerId}
            sx={{
              height: '70px',
              width: '100px',
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
              //スピンボタンの無効化-効いていない
              ':global(input[type="number"]::-webkit-outer-spin-button)': {
                WebkitAppearance: 'none',
                margin: 0,
              },
              ':global(input[type="number"]::-webkit-inner-spin-button)': {
                WebkitAppearance: 'none',
                margin: 0,
              },

              '& .MuiInputBase-input': {
                color: theme.palette.foreColor.main, // テキストフィールド内のフォントカラーをプライマリーカラーに
                fontSize: '16px',
                // その他のスタイル設定...
              },
              '& label': {
                color: theme.palette.foreColor.main, // 通常時のラベル色
                //backgroundColor:"white"
              },
              '& label.Mui-focused': {
                color: theme.palette.foreColor.main, // ラベルの色をprimary.mainに指定
              },
              '& .MuiInput-underline:before': {
                borderBottomColor: theme.palette.foreColor.main, // 通常時のボーダー色
              },
              '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
                borderBottomColor: theme.palette.foreColor.main, // ホバー時のボーダー色
              },
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: theme.palette.foreColor.main, // 通常時のボーダー色(アウトライン)
                },
                '&:hover fieldset': {
                  borderColor: theme.palette.foreColor.main, // ホバー時のボーダー色(アウトライン)
                },
                '& .MuiInputBase-root': {},
              },
            }}
            onChange={handleChangeWorkerId}
            onFocus={handleFocusWorkerId}
            onBlur={handleBlurWorkderId}
            placeholder="1234or01234"
            InputLabelProps={{
              shrink: true,
            }}
          />
        </div>
        <div className={classes.display}>
          <p>{workerInfo.departmentName}</p>
          <p>{workerInfo.workerName}</p>
        </div>
      </div>
      <div className={classes.dateTimeArea}>
        <div className={classes.firstArea}>
          {/* <div className={classes.date}>
            <SingleDatePicker
              disabled={false}
              currentDate={workingDate}
              label={"作業日"}
              onChange={handleWorkingDateChange}
            />
          </div> */}
          <div className={classes.time}>
            <SelectBoxForString
              label={'開始時刻'}
              options={fromTimeList}
              required={true}
              select={handleFromTimeChange}
              value={fromTime}
              disabled={checkFromTimeDisabled()}
              width={'85px'}
              height={'32px'}
              fontSize={'16px'}
              setMode={'input'}
              colorMode={'light'}
            />
          </div>
          {/* 夜勤2直対応: 開始時刻セレクトの直横に夜勤トグル(§4.1) */}
          <NightShiftToggle
            shiftType={shiftType}
            onChange={handleShiftToggle}
            disabled={
              timeToMin(fromTime) < NIGHT_SHIFT_THRESHOLD_MIN &&
              workerInfo.workerName === ''
            }
          />
          {/* <span className={classes.hyphen}>-</span>
          <div className={classes.time}>
            <SelectBoxForString
              label={"終了時刻"}
              options={toTimeList}
              required={true}
              select={setToTime}
              value={toTime}
              disabled={true}
              width={"85px"}
              height={"32px"}
              fontSize={"16px"}
              setMode={"input"}
              colorMode={"light"}
            />
          </div> */}
          {/* <div className={classes.hasBreak}>
            <p
              style={{
                color: hasBreak ? theme.palette.foreColor.main : "#8d94a2",
              }}
            >
              30分休
            </p>
            <Switch
              checked={hasBreak}
              onChange={() => setHasBreak(!hasBreak)}
              sx={{
                ...(!hasBreak
                  ? { color: "#4a4f58" }
                  : { color: theme.palette.foreColor.main }),
              }}
            />
          </div> */}
          <div className={classes.totalTime}>
            <p>終了時刻</p>
            <div
              style={{
                color:
                  totalTime.hour <= 0
                    ? theme.palette.error.main
                    : theme.palette.foreColor.main,
              }}
            >
              {/* 夜勤2直対応: 24h超え時のみ「（翌 H:mm）」併記(§4.2) */}
              <>{formatEndTimeLabel(endMin)}</>
            </div>
          </div>
        </div>
        <div className={classes.secondArea}>
          {/* 夜勤2直対応: ON中は藍色チップを常時表示(§4.1/F1-3) */}
          {shiftType === SHIFT_TYPE_NIGHT && (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '4px',
                backgroundColor: theme.palette.foreColor.main,
                color: '#ffffff',
                borderRadius: '6px',
                padding: '4px 10px',
                fontSize: '13px',
                fontWeight: 'bold',
                whiteSpace: 'nowrap',
                marginRight: '8px',
              }}
            >
              <DarkModeIcon sx={{ fontSize: 16 }} />
              夜勤入力中
            </div>
          )}
          {fromOtherPage && (
            <div className={classes.closeButton}>
              <Buttons
                disabled={false}
                onClick={() => (setIsShow ? setIsShow(false) : undefined)}
                caption={'キャンセル'}
                icon={<CancelIcon />}
                width={26}
                height={26}
                fontSize={26}
              />
            </div>
          )}
        </div>
      </div>
      <div className={classes.hr} />
      {isWorkerSearchOpen && (
        <WorkerSearchDialog
          setIsShow={setIsWorkerSearchOpen}
          setWorkerInfo={setWorkerInfo}
        />
      )}
    </div>
  )
})

export default SingleInputHeader
